import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../utils/appStore";
import { useTheme } from "../utils/ThemeContext";

const Header: React.FC = () => {
    const cartItems = useSelector((state: RootState) => state.cart.items);
    const { theme, toggleTheme } = useTheme();

    return (
        <header className="fixed top-0 left-0 right-0 h-16 bg-white dark:bg-gray-900 shadow-sm z-50 flex items-center justify-between px-4 md:px-12 transition-colors duration-200 border-b border-gray-100 dark:border-gray-800">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-2">
                <span className="text-2xl">🍽️</span>
                <span className="text-xl font-bold text-gray-900 dark:text-white">
                    Easy<span className="text-orange-500">Eats</span>
                </span>
            </Link>

            {/* Navigation */}
            <nav className="flex items-center gap-1 md:gap-2">
                <button
                    onClick={toggleTheme}
                    className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-600 dark:text-gray-300 transition-colors mr-2"
                    aria-label="Toggle theme"
                >
                    {theme === 'light' ? (
                        <i className="fa-solid fa-moon"></i>
                    ) : (
                        <i className="fa-solid fa-sun"></i>
                    )}
                </button>
                <Link
                    to="/"
                    className="hidden md:flex items-center gap-2 px-4 py-2 text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg font-medium text-sm transition-colors"
                >
                    <i className="fa-solid fa-house text-xs"></i>
                    Home
                </Link>
                <Link
                    to="/cart"
                    className="flex items-center gap-2 px-4 py-2 bg-orange-500 hover:bg-orange-600 text-white rounded-full font-medium text-sm transition-colors relative"
                >
                    <i className="fa-solid fa-bag-shopping text-sm"></i>
                    <span className="hidden sm:inline">Cart</span>
                    {cartItems.length > 0 && (
                        <span className="absolute -top-1 -right-1 bg-gray-900 dark:bg-white text-white dark:text-gray-900 text-xs font-bold min-w-[20px] h-5 rounded-full flex items-center justify-center">
                            {cartItems.length}
                        </span>
                    )}
                </Link>
            </nav>
        </header>
    );
};

export default Header;

